module.exports = __webpack_public_path__ + "static/media/reporting-portal-logo.a1eae7df.png";